import { useMemo } from 'react'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  SchedulerResourceAndOutputMappingRowType,
} from './Scheduler.types'
import { Box } from '@mui/material'
const dataConfig = {
  required: ['productCode', 'resource', 'runRate', 'workStationCode'],
  optional: ['productName'],
}

export const SchedulerResourceAndOutputMappingTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
}: SheduleTableProps<SchedulerResourceAndOutputMappingRowType>) => {
  // Handle data updates for BaseTable
  const handleDataUpdate = (
    changedRows: Record<number, SchedulerResourceAndOutputMappingRowType>
  ) => {
    updateTableData(changedRows)
  }
  //Example data:
  //   {
  //     "id": 0,
  //     "productCode": "901732915",
  //     "resource": "sugar",
  //     "runRate": "6.201"
  // }
  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        field: 'productCode',
        headerName: 'Product Code',
        type: 'string',
        flex: 1,
      },
      {
        field: 'productName',
        headerName: 'Product Description',
        type: 'string',
        flex: 1,
      },
      {
        field: 'resource',
        headerName: 'Resource Constraint Name',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        field: 'runRate',
        headerName: 'Run Rate',
        editable: true,
        flex: 1,
        type: 'number',
      },
      {
        field: 'workStationCode',
        headerName: 'Work Station Code',
        type: 'string',
        flex: 1,
      },
    ],
    [data]
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName="SchedulerResourceAndOutputMapping"
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: {
            required: ['productCode', 'resource', 'runRate', 'workStationCode'],
            optional: ['productName'],
          },
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
